import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./QuienesSomos.css";

const About = () => {
  const { t } = useTranslation("quienessomos");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main className="about-page">
      <section className="about-hero">
        <div className="about-hero__inner">
          <h1>
            {t("hero.titleRest")} <span>{t("hero.titleHighlight")}</span>
          </h1>
          <p>{t("hero.description")}</p>
        </div>
      </section>

      <section className="about-content">
        <article className="about-story">
          <p>{t("body.p1")}</p>

          <p>{t("body.p2")}</p>

          <div className="about-highlight">
            <p>{t("body.highlight")}</p>
          </div>
        </article>
      </section>
    </main>
  );
};

export default About;
